// extracted by mini-css-extract-plugin
export default {"title":"AddPost_title__I7f4I","subtitle":"AddPost_subtitle__NKTbi","image":"AddPost_image__H7ExR","buttons":"AddPost_buttons__IifkQ"};